import React from 'react'

const GraphicDesign = () => {
  return (
    <div>GraphicDesign</div>
  )
}

export default GraphicDesign